import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/tipo_permiso/tipo_permiso';
import CrearEditar from './CrearEditar';

const ms2p = (state) => {
  return {
    ...state.tipos_permiso,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(CrearEditar);
